module.exports = __webpack_public_path__ + "img/gld_gbt822_2000.prt.831d538d.jpg";